import { render } from "./main-products.vue?vue&type=template&id=0b0b0848"
import script from "./main-products.vue?vue&type=script&lang=js"
export * from "./main-products.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__